// extracted by mini-css-extract-plugin
export default {"container":"GoalModal_container__mXvgZ","nextGoal":"GoalModal_nextGoal__82KXS","likeAnimation":"GoalModal_likeAnimation__5W35U"};